import React from 'react';
import './Footer.css';

const Footer = ({ contacts }) => {
  const hasContacts = Array.isArray(contacts) && contacts.length > 0;

  return (
    <footer className="footer" role="contentinfo">
      <div className="section-container">
        {/* Decorative Divider */}
        <div className="footer__divider" aria-hidden="true" />

        {/* Optional contact numbers */}
        {hasContacts && (
          <ul className="footer__contacts">
            {contacts.map(({ name, phone }) => (
              <li key={`${name}-${phone}`} className="footer__contact">
                <span className="footer__contact-name">{name}</span>
                <a
                  href={`tel:${phone.replace(/\s+/g, '')}`}
                  className="footer__contact-phone"
                >
                  {phone}
                </a>
              </li>
            ))}
          </ul>
        )}

        {/* Closing Message */}
        <p className="footer__message">
          S ljubavlju, Ana i Josip
        </p>

        {/* Secondary Line
        <p className="footer__secondary">
          Thank you for celebrating with us
          <span className="footer__heart" aria-hidden="true">♥</span>
          2025
        </p> */}
      </div>
    </footer>
  );
};

export default Footer;
